import React from "react";
import styled from 'styled-components'
import {NavLink} from 'react-router-dom'
import {LoginWidget} from "../login/login";

export const NavWidget: React.FC = () => {


    return (<div>

        <StyledLink to="/personal">Dashboard</StyledLink>
        <StyledLink to="/claims">Claims</StyledLink>
        {/*<LoginWidget />*/}
    </div>);
}


const StyledLink = styled(NavLink)`
    color: white;
  font-weight: 700;
  margin-right: 20px;
  
  
  text-decoration: none;
  &:hover {
  
  }
  &.active {
  
background: linear-gradient(90deg, #CE45C5 0%, #5592E8 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

  }
  @media (max-width: 768px) {
  
    font-size: 10px;

  }
`;
